import BaseComponent from '../BaseComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'VenueDateEdit';
const SELECTOR_PAGE = '.lta-venue-date-edit';
const SELECTOR_TRIGGER_EXIT_BUTTON = '.js-exit-venue-date-edit-modal';
const SELECTOR_TRIGGER_CANCEL_BUTTON = '.js-cancel-venue-date-edit-modal';
const SELECTOR_TRIGGER_SAVE_BUTTON = '.js-save-venue-date-edit-modal';
const SELECTOR_DATE_PICKER = '.js-venue-date-picker';

const EVENT_CLICK = `click`;

class VenueDateEdit extends BaseComponent {

	constructor(element) {
		super(element);
		this.state = {
			date: ''
		}
		this._saveCallbacks = [];
		this._cancelCallbacks = [];
		this.init();
		this.disableDatePickerManualEntry();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		this._wrapperElement = SelectorEngine.findOne(SELECTOR_PAGE);

		if (!this._wrapperElement) {
			return;
		}
		this._venueDatePicker = SelectorEngine.findOne(SELECTOR_DATE_PICKER, this._wrapperElement);
		this._venueDetailsModalExitButton = SelectorEngine.findOne(SELECTOR_TRIGGER_EXIT_BUTTON, this._wrapperElement);
		this._venueDetailsModalCancelButton = SelectorEngine.findOne(SELECTOR_TRIGGER_CANCEL_BUTTON, this._wrapperElement);

		this._venueDetailsModalsaveButton = SelectorEngine.findOne(SELECTOR_TRIGGER_SAVE_BUTTON, this._wrapperElement);

		this._venueDetailsModalsaveButton.disabled = true;
		
		EventHandler.on(this._venueDetailsModalExitButton, EVENT_CLICK , this.onCancelClickHandler.bind(this));
		EventHandler.on(this._venueDetailsModalCancelButton, EVENT_CLICK , this.onCancelClickHandler.bind(this));

		EventHandler.on(this._venueDetailsModalsaveButton, EVENT_CLICK , this.onSaveClickHandler.bind(this));

		const last2weeks = [...Array(16)].map((_, i) => { const d = new Date(); d.setDate(d.getDate() - i); return d })
		if(this._venueDatePicker) {
			this._venueDatePicker.setAttribute("min", last2weeks[14].toISOString().split('T')[0]);
			this._venueDatePicker.setAttribute("max", new Date(Date.now()).toISOString().split('T')[0]);	
		};


		EventHandler.on(this._venueDatePicker, "duetChange", (e) => {
			if(e.target.value != null && e.target.value != '') {
				this.state.date = e.target.value;
				this._venueDetailsModalsaveButton.disabled = false;
			}
		});
	}

	disableDatePickerManualEntry() {
		setTimeout(() => {
			document.querySelector('.js-venue-date-picker .duet-date__input').setAttribute('readonly', true);
			document.querySelector('.js-venue-date-picker .duet-date__input').addEventListener('click', function () {
			document.querySelector(".js-venue-date-picker").show();
		});
		}, 5000);
	}


	onCancel(callback){
		this._cancelCallbacks.push(callback);
	}

	onCancelClickHandler(){
		for (const callback of this._cancelCallbacks) {
			callback();
		}
	}

	onSave(callback) {
		this._saveCallbacks.push(callback);
	}

	onSaveClickHandler() {
		for (const callback of this._saveCallbacks) {
			callback(this.state.date);
		}
		document.getElementById('date_updated').value = this.state.date;
		document.getElementById('confirm-result').classList.add('u-hidden');
		document.getElementById('dispute-result').classList.remove('u-hidden');
	}
}

export default VenueDateEdit;
